// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FuD1ob2JCIGJ7Ad9{width:100%;height:264px;display:grid;place-items:center}.FuD1ob2JCIGJ7Ad9 .BnEfrfnAsU9tw627{text-align:center;width:234px;height:48px}.YNtN54AclD8Xkcx_{border-radius:4px;background-color:var(--py-neutral-1);padding:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"factorsPolygon": `FuD1ob2JCIGJ7Ad9`,
	"noDataMessage": `BnEfrfnAsU9tw627`,
	"selectionChip": `YNtN54AclD8Xkcx_`
};
export default ___CSS_LOADER_EXPORT___;
